(() => {
  const COPA_IMAGES = {
    1: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/patch1.png?v=1785211217',
    2: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/patch2.png?v=1785211220',
    4: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/patch3.png?v=1785211215',
    5: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/patch5.png?v=1785211212',
    6: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/patch6.png?v=1785211209'
  };

  const LIB_IMAGES = {
    1: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/aa811980-53af-49d2-a9c7-4f61829bfa40_072c381f-c4ba-475d-8174-ac1bc60cbc62.png?v=1785219457',
    2: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/Design_sem_nome_53_d9364173-972b-4f02-9e67-af7ae5133f2f.webp?v=1785219905',
    3: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/Design_sem_nome_54_8ffedb57-0cd3-474f-aee0-55e1d77d2bde.webp?v=1785219908',
    4: 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191388/Titulos_lib.png'
  };

  const SUD_IMAGE = 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/sulamericana_b24c59f6-087b-41ec-888f-f8a9cd2d8fea.webp?v=1785219897';

  const TEAM = {
    'atletico-mineiro': { copa: 2, lib: 1, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/atleticomineiro.png?v=1786567045' },
    'bahia': { copa: 0, lib: 0, sud: 0 },
    'botafogo': { copa: 0, lib: 1, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/botafogo.png?v=1786567051' },
    'ceara': { copa: 0, lib: 0, sud: 0 },
    'corinthians': { copa: 4, lib: 1, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/corinthians.png?v=1786567042' },
    'cruzeiro': { copa: 6, lib: 2, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/cruzeiro.png?v=1786567040' },
    'flamengo': { copa: 5, lib: 4, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/flamengo.png?v=1786567052' },
    'fluminense': { copa: 1, lib: 1, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/fluminense.png?v=1786567050' },
    'fortaleza': { copa: 0, lib: 0, sud: 0 },
    'gremio': { copa: 5, lib: 3, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/gremio.png?v=1786567055' },
    'internacional': { copa: 1, lib: 2, sud: 1, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/internacional.png?v=1786567046' },
    'juventude': { copa: 1, lib: 0, sud: 0 },
    'mirassol': { copa: 0, lib: 0, sud: 0 },
    'palmeiras': { copa: 4, lib: 3, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/palmeiras.png?v=1786567043' },
    'red-bull-bragantino': { copa: 0, lib: 0, sud: 0 },
    'santos': { copa: 1, lib: 3, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/santos_7086c2bd-d898-440e-a12d-9d3eabc9c31e.png?v=1786567047' },
    'sao-paulo': { copa: 1, lib: 3, sud: 1, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/saopaulo.png?v=1786567049' },
    'sport-recife': { copa: 1, lib: 0, sud: 0 },
    'vasco-da-gama': { copa: 1, lib: 1, sud: 0, libChampion: 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/vasco_e2ebee9e-7452-4068-8562-01c6afa811a7.png?v=1786567054' },
    'vitoria': { copa: 0, lib: 0, sud: 0 }
  };

  const FLAMENGO_OFFICIAL = new Map([
    ['libertadores - 4 titles', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191388/Titulos_lib.png'],
    ['patch comemorativo 4 tacas libertadores', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191388/Titulos_lib.png'],
    ['copa libertadores 2025', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191389/Patch-Campeon-25.png'],
    ['patch campeao libertadores 2025', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191389/Patch-Campeon-25.png'],
    ['brasileirao betano 2025', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191387/image-removebg-preview---2026-07-15T141438.449.png'],
    ['patch campeao brasileiro 2025', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191387/image-removebg-preview---2026-07-15T141438.449.png'],
    ['kit patches libertadores 2026', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/191390/Kitlib26.png'],
    ['patch brasil flamengo 2026 un', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/189714/image-removebg-preview---2026-05-28T094253.139.png'],
    ['patch zico crf', 'https://lojaflamengo.vteximg.com.br/arquivos/ids/165197/zico.png'],
    ['fifa club world cup 2025', 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/participationworldcup_580adab1-24c1-4fda-8ac7-7ddf1c487696.webp?v=1785219858'],
    ['patch world cup 2025 participation', 'https://cdn.shopify.com/s/files/1/0858/8286/3650/files/participationworldcup_580adab1-24c1-4fda-8ac7-7ddf1c487696.webp?v=1785219858']
  ]);

  const fold = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

  function teamKey(card) {
    return card.closest('jersey-personalizer')?.dataset.team || '';
  }

  function showPlaceholder(art) {
    if (!art) return;
    art.innerHTML = '';
    art.removeAttribute('data-patch-image');
    const span = document.createElement('span');
    span.textContent = 'PATCH';
    span.setAttribute('aria-hidden', 'true');
    span.style.cssText = 'font-size:11px;font-weight:700;line-height:1;color:#333;text-align:center;';
    art.append(span);
  }

  function installImage(art, src) {
    if (!art || !src) return false;
    const current = art.querySelector('img');
    if (current && current.dataset.js360RepairSrc === src && current.complete && current.naturalWidth > 0) return true;
    art.innerHTML = '';
    art.dataset.patchImage = src;
    const img = new Image();
    img.alt = '';
    img.decoding = 'async';
    img.loading = 'lazy';
    img.dataset.js360RepairSrc = src;
    img.onerror = () => showPlaceholder(art);
    img.src = src;
    art.append(img);
    return true;
  }

  function removeOption(card) {
    const row = card.closest('[data-patch-row]');
    const select = row?.querySelector('[data-patch-title]');
    const value = card.dataset.patchValue || '';
    if (!select || !value) return;
    [...select.options].forEach((option) => {
      if (option.value === value) option.remove();
    });
    if (select.value === value) select.value = '';
  }

  function hideCard(card) {
    removeOption(card);
    card.hidden = true;
    card.style.display = 'none';
  }

  function resolve(card) {
    const name = card.querySelector('.js360-zone__patch-name')?.textContent || card.dataset.patchValue || '';
    const key = fold(name);
    const team = teamKey(card);
    const data = TEAM[team];

    if (team === 'flamengo') {
      const official = FLAMENGO_OFFICIAL.get(key);
      if (official) return { valid: true, image: official };
    }

    if (key === 'brasileirao betano 2025') {
      return team === 'flamengo'
        ? { valid: true, image: FLAMENGO_OFFICIAL.get(key) }
        : { valid: false };
    }

    if (key === 'copa do brasil') {
      if (!data || !data.copa) return { valid: false };
      return { valid: true, image: COPA_IMAGES[data.copa] || '' };
    }

    if (key === 'conmebol libertadores') {
      if (!data || !data.lib || !data.libChampion) return { valid: false };
      return { valid: true, image: data.libChampion };
    }

    if (key.includes('campeao da libertadores')) {
      if (!data || !data.lib || !data.libChampion) return { valid: false };
      return { valid: true, image: data.libChampion };
    }

    const libTitleMatch = key.match(/libertadores\s*-?\s*(\d+)\s*(?:title|titles|titulo|titulos|trophies)/);
    if (libTitleMatch) {
      const count = Number(libTitleMatch[1]);
      if (!data || !data.lib || count !== data.lib) return { valid: false };
      return { valid: true, image: LIB_IMAGES[count] || '' };
    }

    if (key === 'conmebol sudamericana' || key.includes('campeao da sudamericana')) {
      if (!data || !data.sud) return { valid: false };
      return { valid: true, image: SUD_IMAGE };
    }

    const sudTitleMatch = key.match(/sudamericana\s*-?\s*(\d+)\s*(?:title|titles|titulo|titulos|trophies)/);
    if (sudTitleMatch) {
      const count = Number(sudTitleMatch[1]);
      if (!data || !data.sud || count !== data.sud) return { valid: false };
      return { valid: true, image: SUD_IMAGE };
    }

    return { valid: true, image: '' };
  }

  function repairCard(card) {
    const art = card.querySelector('.js360-zone__patch-art');
    if (!art) return;
    const result = resolve(card);
    if (!result.valid) {
      hideCard(card);
      return;
    }

    card.hidden = false;
    if (card.style.display === 'none') card.style.display = '';

    if (result.image) {
      installImage(art, result.image);
      return;
    }

    const img = art.querySelector('img');
    if (!img) return;
    img.alt = '';
    img.onerror = () => showPlaceholder(art);
    if (img.complete && !img.naturalWidth) showPlaceholder(art);
  }

  function repair(scope = document) {
    scope.querySelectorAll?.('[data-patch-card]').forEach(repairCard);
    scope.querySelectorAll?.('[data-patch-row]').forEach((row) => {
      const visible = [...row.querySelectorAll('[data-patch-card]')]
        .some((card) => !card.hidden && card.style.display !== 'none');
      row.hidden = !visible;
      row.style.display = visible ? '' : 'none';
    });
  }

  repair();
  new MutationObserver(() => requestAnimationFrame(() => repair())).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener('click', () => setTimeout(repair, 0), true);
})();
